import { Box, BoxProps, Button, Grid, Stack, Typography } from "@mui/material"
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { DadosTitulosItems } from "..";
import { useState } from "react";
import { verificarStringVazia } from "../../../../../../../helpers/verificadores";
import DialogEdit from "./DialogEdit";
import { IDetalharTituloPagar } from "../../../../../../../types/api/financeiro/detalhar-titulo-pagar";
import { formatarCPFCNPJ } from "../../../../../../../helpers/masks";
import { usePermission } from "../../../../../../../components/PermissionGuard";

export default function CardDadosPagamento({
    boxStyle, detalhe, codigo
}: CardDadosPagamentoProps) {

    const podeEditar = usePermission('financeiro.contas-receber-editar')
    const [openEdit, setOpenEdit] = useState(false)

    return (
        <Box {...boxStyle}>
            <Typography variant="h6">Dados para pagamento</Typography>

            <Grid container rowGap={2}>
                <Grid size={{xs: 6}}>
                    <DadosTitulosItems titulo="Banco" valor={detalhe.banco_pagamento ? `${detalhe.banco_pagamento.codigo} - ${detalhe.banco_pagamento.nome}` : "-"} />
                </Grid>

                <Grid size={{xs: 6, md: 3}}>
                    <DadosTitulosItems titulo="Agência" valor={detalhe.agencia_pagamento ? `${detalhe.agencia_pagamento}` : "-"} />
                </Grid>

                <Grid size={{xs: 6, md: 3}}>
                    <DadosTitulosItems titulo="Conta" valor={detalhe.conta_pagamento ? `${detalhe.conta_pagamento}` : "-"} />
                </Grid>

                <Grid size={{xs: 6}}>
                    <DadosTitulosItems titulo="Nome do favorecido" valor={detalhe.nome_favorecido ? `${detalhe.nome_favorecido}` : "-"} />
                </Grid>
                <Grid size={{xs: 6}}>
                    <DadosTitulosItems titulo="Tipo pessoa" valor={detalhe.tipo_documento_favorecido ? verificarTipoDocumentoLabel(detalhe.tipo_documento_favorecido) : "-"} />
                </Grid>

                <Grid size={{xs: 6}}>
                    <DadosTitulosItems titulo="Documento do favorecido" valor={detalhe.documento_favorecido ? `${formatarCPFCNPJ(detalhe.documento_favorecido)}` : "-"} />
                </Grid>

                <Grid size={{xs: 6}}>
                    <DadosTitulosItems titulo="Forma de pagamento" valor={detalhe.forma_pagamento ? `${detalhe.forma_pagamento}` : "-"} />
                </Grid>

                <Grid size={{xs: 6}}>
                    <DadosTitulosItems titulo="Código de barras" valor={verificarStringVazia(detalhe.chave_pix)} />
                </Grid>

                <Grid size={{xs: 6}}>
                    <DadosTitulosItems titulo="Chave pix" valor={verificarStringVazia(detalhe.chave_pix)} />
                </Grid>
            </Grid>

            <Typography mb={1} variant="h6">Dados contábeis</Typography>

            <Grid container rowGap={2}>
                <Grid size={{xs: 6}}>
                    <Stack>
                        <Typography fontWeight="bold" variant="subtitle2">Conta devedora</Typography>
                        <Stack>
                            <Typography variant="subtitle2">
                                {detalhe.conta_devedora ?
                                    `${detalhe.conta_devedora.codigo_contabil} - ${detalhe.conta_devedora.nome}` : "-"}
                            </Typography>
                            {
                                detalhe.centro_custo_devedora &&
                                <Typography variant="caption" color="gray">
                                    Centro custo: {`${detalhe.centro_custo_devedora.id} - ${detalhe.centro_custo_devedora.nome}`}
                                </Typography>
                            }
                        </Stack>
                    </Stack>
                </Grid>

                <Grid size={{xs: 6}}>
                    <Stack>
                        <Typography fontWeight="bold" variant="subtitle2">Contra credora</Typography>
                        <Stack>
                            <Typography variant="subtitle2">
                                {detalhe.conta_credora ?
                                    `${detalhe.conta_credora.codigo_contabil} - ${detalhe.conta_credora.nome}` : "-"}
                            </Typography>
                            {
                                detalhe.centro_custo_credora &&
                                <Typography variant="caption" color="gray">
                                    Centro custo: {`${detalhe.centro_custo_credora.id} - ${detalhe.centro_custo_credora.nome}`}
                                </Typography>
                            }
                        </Stack>
                    </Stack>
                </Grid>

                <Grid size={{xs: 12}}>
                    <DadosTitulosItems titulo="Natureza rendimento" valor={detalhe.natureza_rendimento ? `${detalhe.natureza_rendimento.codigo} - ${detalhe.natureza_rendimento.nome}` : "-"} />
                </Grid>
            </Grid>

            {
                podeEditar &&
                <Stack direction="row" justifyContent="flex-end">
                    <Button
                        variant="contained"
                        size="small"
                        startIcon={<EditOutlinedIcon />}
                        sx={{ fontSize: '0.75rem' }}
                        onClick={() => setOpenEdit(true)}
                    >
                        Editar
                    </Button>
                </Stack>
            }

            {
                openEdit &&
                <DialogEdit
                    {...{ codigo }}
                    open={openEdit}
                    handleClose={() => setOpenEdit(false)}
                    titulo={detalhe}
                />
            }
        </Box>
    )
}

interface CardDadosPagamentoProps {
    boxStyle: BoxProps,
    codigo: string,
    detalhe: IDetalharTituloPagar
}

const verificarTipoDocumentoLabel = (tipo: string) => {
    switch (tipo.trim().toUpperCase()) {
        case "J": return "Pessoa jurídica";
        case "F": return "Pessoa física";
        default: return "Não informado";
    }
}